/**
 * A user interface background.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#000000` / `rgb(0, 0, 0)`
 */
export const bg = 'var(--cb-color-bg)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#EDEDEE` / `rgb(237, 237, 238)`
 *   - dark: `#1F1F1F` / `rgb(31, 31, 31)`
 */
export const bgSurface = 'var(--cb-color-bg-surface)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#DBDBDC` / `rgb(219, 219, 220)`
 *   - dark: `#333333` / `rgb(51, 51, 51)`
 */
export const bgSurfaceHovered = 'var(--cb-color-bg-surface-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#C9CACB` / `rgb(201, 202, 203)`
 *   - dark: `#3D3D3D` / `rgb(61, 61, 61)`
 */
export const bgSurfacePressed = 'var(--cb-color-bg-surface-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E4E4E5` / `rgb(228, 228, 229)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const bgSurfaceSelected = 'var(--cb-color-bg-surface-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#F6F6F6` / `rgb(246, 246, 246)`
 *   - dark: `#141414` / `rgb(20, 20, 20)`
 */
export const bgSurfaceDisabled = 'var(--cb-color-bg-surface-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#F6F6F6` / `rgb(246, 246, 246)`
 *   - dark: `#141414` / `rgb(20, 20, 20)`
 */
export const bgSurfaceSecondary = 'var(--cb-color-bg-surface-secondary)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#EDEDEE` / `rgb(237, 237, 238)`
 *   - dark: `#1F1F1F` / `rgb(31, 31, 31)`
 */
export const bgSurfaceSecondaryHovered = 'var(--cb-color-bg-surface-secondary-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#DBDBDC` / `rgb(219, 219, 220)`
 *   - dark: `#333333` / `rgb(51, 51, 51)`
 */
export const bgSurfaceSecondaryPressed = 'var(--cb-color-bg-surface-secondary-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E4E4E5` / `rgb(228, 228, 229)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const bgSurfaceSecondarySelected = 'var(--cb-color-bg-surface-secondary-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#F6F6F6` / `rgb(246, 246, 246)`
 *   - dark: `#141414` / `rgb(20, 20, 20)`
 */
export const bgSurfaceSecondaryDisabled = 'var(--cb-color-bg-surface-secondary-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF00` / `rgba(255, 255, 255, 0)`
 *   - dark: `#00000000` / `rgba(0, 0, 0, 0)`
 */
export const bgSurfaceTertiary = 'var(--cb-color-bg-surface-tertiary)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#F6F6F6` / `rgb(246, 246, 246)`
 *   - dark: `#141414` / `rgb(20, 20, 20)`
 */
export const bgSurfaceTertiaryHovered = 'var(--cb-color-bg-surface-tertiary-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#E4E4E4` / `rgb(228, 228, 228)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const bgSurfaceTertiaryPressed = 'var(--cb-color-bg-surface-tertiary-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#EEEEEE` / `rgb(238, 238, 238)`
 *   - dark: `#1F1F1F` / `rgb(31, 31, 31)`
 */
export const bgSurfaceTertiarySelected = 'var(--cb-color-bg-surface-tertiary-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF00` / `rgba(255, 255, 255, 0)`
 *   - dark: `#00000000` / `rgba(0, 0, 0, 0)`
 */
export const bgSurfaceTertiaryDisabled = 'var(--cb-color-bg-surface-tertiary-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#000000` / `rgb(0, 0, 0)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const bgFill = 'var(--cb-color-bg-fill)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#1F1F1F` / `rgb(31, 31, 31)`
 *   - dark: `#EBEBEB` / `rgb(235, 235, 235)`
 */
export const bgFillHovered = 'var(--cb-color-bg-fill-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#333333` / `rgb(51, 51, 51)`
 *   - dark: `#E0E0E0` / `rgb(224, 224, 224)`
 */
export const bgFillPressed = 'var(--cb-color-bg-fill-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#292929` / `rgb(41, 41, 41)`
 *   - dark: `#EBEBEB` / `rgb(235, 235, 235)`
 */
export const bgFillSelected = 'var(--cb-color-bg-fill-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#5C5C5C` / `rgb(92, 92, 92)`
 *   - dark: `#F5F5F5` / `rgb(245, 245, 245)`
 */
export const bgFillDisabled = 'var(--cb-color-bg-fill-disabled)';

/**
 * A label containing content of importance.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const text = 'var(--cb-color-text)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#202125EB` / `rgba(32, 33, 37, 0.92)`
 *   - dark: `#FFFFFFEB` / `rgba(255, 255, 255, 0.92)`
 */
export const textHovered = 'var(--cb-color-text-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#202125CC` / `rgba(32, 33, 37, 0.8)`
 *   - dark: `#FFFFFFCC` / `rgba(255, 255, 255, 0.8)`
 */
export const textPressed = 'var(--cb-color-text-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#202125E0` / `rgba(32, 33, 37, 0.88)`
 *   - dark: `#FFFFFFE0` / `rgba(255, 255, 255, 0.88)`
 */
export const textSelected = 'var(--cb-color-text-selected)';

/**
 * A label that’s interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#20212566` / `rgba(32, 33, 37, 0.4)`
 *   - dark: `#FFFFFF66` / `rgba(255, 255, 255, 0.4)`
 */
export const textDisabled = 'var(--cb-color-text-disabled)';

/**
 * A label containing content of lesser importance.
 *
 * Reference color on default theme:
 *   - light: `#202125A3` / `rgba(32, 33, 37, 0.64)`
 *   - dark: `#FFFFFFA3` / `rgba(255, 255, 255, 0.64)`
 */
export const textSubdued = 'var(--cb-color-text-subdued)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFill = 'var(--cb-color-text-on-bg-fill)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillHovered = 'var(--cb-color-text-on-bg-fill-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillPressed = 'var(--cb-color-text-on-bg-fill-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillSelected = 'var(--cb-color-text-on-bg-fill-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#9D9D9D` / `rgb(157, 157, 157)`
 *   - dark: `#A0A0A2` / `rgb(160, 160, 162)`
 */
export const textOnBgFillDisabled = 'var(--cb-color-text-on-bg-fill-disabled)';

/**
 * A boundary of an item that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#E4E4E5` / `rgb(228, 228, 229)`
 *   - dark: `#333333` / `rgb(51, 51, 51)`
 */
export const border = 'var(--cb-color-border)';

/**
 * A boundary of an item that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#C9CACB` / `rgb(201, 202, 203)`
 *   - dark: `#525252` / `rgb(82, 82, 82)`
 */
export const borderHovered = 'var(--cb-color-border-hovered)';

/**
 * A boundary of an item that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#B8B8B9` / `rgb(184, 184, 185)`
 *   - dark: `#666666` / `rgb(102, 102, 102)`
 */
export const borderPressed = 'var(--cb-color-border-pressed)';

/**
 * A boundary of an item that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#009DE0` / `rgb(0, 157, 224)`
 *   - dark: `#009DE0` / `rgb(0, 157, 224)`
 */
export const borderSelected = 'var(--cb-color-border-selected)';

/**
 * A boundary of an item that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#EDEDEE` / `rgb(237, 237, 238)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const borderDisabled = 'var(--cb-color-border-disabled)';

/**
 * A boundary of an item that's decorative.
 *
 * Reference color on default theme:
 *   - light: `#EDEDEE` / `rgb(237, 237, 238)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const borderSubdued = 'var(--cb-color-border-subdued)';

/**
 * A boundary of an item alerting of an negative.
 *
 * Reference color on default theme:
 *   - light: `#F93A25` / `rgb(249, 58, 37)`
 *   - dark: `#F93A25` / `rgb(249, 58, 37)`
 */
export const borderNegative = 'var(--cb-color-border-negative)';

/**
 * A boundary of an item that's on focus.
 *
 * Reference color on default theme:
 *   - light: `#0F2594` / `rgb(15, 37, 148)`
 *   - dark: `#FEA90D` / `rgb(254, 169, 13)`
 */
export const outlineFocused = 'var(--cb-color-outline-focused)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#EBF7FD` / `rgb(235, 247, 253)`
 *   - dark: `#001924` / `rgb(0, 25, 36)`
 */
export const bgSurfaceBrand = 'var(--cb-color-bg-surface-brand)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#D6EFFA` / `rgb(214, 239, 250)`
 *   - dark: `#002636` / `rgb(0, 38, 54)`
 */
export const bgSurfaceBrandHovered = 'var(--cb-color-bg-surface-brand-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#C2E7F8` / `rgb(194, 231, 248)`
 *   - dark: `#003248` / `rgb(0, 50, 72)`
 */
export const bgSurfaceBrandPressed = 'var(--cb-color-bg-surface-brand-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E0F3FB` / `rgb(224, 243, 251)`
 *   - dark: `#002C3F` / `rgb(0, 44, 63)`
 */
export const bgSurfaceBrandSelected = 'var(--cb-color-bg-surface-brand-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#F5FBFE` / `rgb(245, 251, 254)`
 *   - dark: `#00131B` / `rgb(0, 19, 27)`
 */
export const bgSurfaceBrandDisabled = 'var(--cb-color-bg-surface-brand-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#009DE0` / `rgb(0, 157, 224)`
 *   - dark: `#009DE0` / `rgb(0, 157, 224)`
 */
export const bgFillBrand = 'var(--cb-color-bg-fill-brand)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#1FA9E4` / `rgb(31, 169, 228)`
 *   - dark: `#008AC5` / `rgb(0, 138, 197)`
 */
export const bgFillBrandHovered = 'var(--cb-color-bg-fill-brand-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#33B1E6` / `rgb(51, 177, 230)`
 *   - dark: `#0071A1` / `rgb(0, 113, 161)`
 */
export const bgFillBrandPressed = 'var(--cb-color-bg-fill-brand-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#29ADE5` / `rgb(41, 173, 229)`
 *   - dark: `#0084BC` / `rgb(0, 132, 188)`
 */
export const bgFillBrandSelected = 'var(--cb-color-bg-fill-brand-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#5CC0EB` / `rgb(92, 192, 235)`
 *   - dark: `#00648F` / `rgb(0, 100, 143)`
 */
export const bgFillBrandDisabled = 'var(--cb-color-bg-fill-brand-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#009DE0` / `rgb(0, 157, 224)`
 *   - dark: `#009DE0` / `rgb(0, 157, 224)`
 */
export const textBrand = 'var(--cb-color-text-brand)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#009DE0EB` / `rgba(0, 157, 224, 0.92)`
 *   - dark: `#009DE0EB` / `rgba(0, 157, 224, 0.92)`
 */
export const textBrandHovered = 'var(--cb-color-text-brand-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#009DE0CC` / `rgba(0, 157, 224, 0.8)`
 *   - dark: `#009DE0CC` / `rgba(0, 157, 224, 0.8)`
 */
export const textBrandPressed = 'var(--cb-color-text-brand-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#009DE0E0` / `rgba(0, 157, 224, 0.88)`
 *   - dark: `#009DE0E0` / `rgba(0, 157, 224, 0.88)`
 */
export const textBrandSelected = 'var(--cb-color-text-brand-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#009DE066` / `rgba(0, 157, 224, 0.4)`
 *   - dark: `#009DE066` / `rgba(0, 157, 224, 0.4)`
 */
export const textBrandDisabled = 'var(--cb-color-text-brand-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillBrand = 'var(--cb-color-text-on-bg-fill-brand)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillBrandHovered = 'var(--cb-color-text-on-bg-fill-brand-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillBrandPressed = 'var(--cb-color-text-on-bg-fill-brand-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#202125` / `rgb(32, 33, 37)`
 */
export const textOnBgFillBrandSelected = 'var(--cb-color-text-on-bg-fill-brand-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF66` / `rgba(255, 255, 255, 0.4)`
 *   - dark: `#2021257A` / `rgba(32, 33, 37, 0.48)`
 */
export const textOnBgFillBrandDisabled = 'var(--cb-color-text-on-bg-fill-brand-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFEFEE` / `rgb(255, 239, 238)`
 *   - dark: `#280906` / `rgb(40, 9, 6)`
 */
export const bgSurfaceNegative = 'var(--cb-color-bg-surface-negative)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FEDFDC` / `rgb(254, 223, 220)`
 *   - dark: `#3C0E09` / `rgb(60, 14, 9)`
 */
export const bgSurfaceNegativeHovered = 'var(--cb-color-bg-surface-negative-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FED0CB` / `rgb(254, 208, 203)`
 *   - dark: `#50130C` / `rgb(80, 19, 12)`
 */
export const bgSurfaceNegativePressed = 'var(--cb-color-bg-surface-negative-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FEE7E5` / `rgb(254, 231, 229)`
 *   - dark: `#320C07` / `rgb(50, 12, 7)`
 */
export const bgSurfaceNegativeSelected = 'var(--cb-color-bg-surface-negative-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFF7F6` / `rgb(255, 247, 246)`
 *   - dark: `#1E0704` / `rgb(30, 7, 4)`
 */
export const bgSurfaceNegativeDisabled = 'var(--cb-color-bg-surface-negative-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#F93A25` / `rgb(249, 58, 37)`
 *   - dark: `#F93A25` / `rgb(249, 58, 37)`
 */
export const bgFillNegative = 'var(--cb-color-bg-fill-negative)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FA523F` / `rgb(250, 82, 63)`
 *   - dark: `#DB3321` / `rgb(219, 51, 33)`
 */
export const bgFillNegativeHovered = 'var(--cb-color-bg-fill-negative-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FA6151` / `rgb(250, 97, 81)`
 *   - dark: `#B32A1B` / `rgb(179, 42, 27)`
 */
export const bgFillNegativePressed = 'var(--cb-color-bg-fill-negative-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FA5A48` / `rgb(250, 90, 72)`
 *   - dark: `#D1311F` / `rgb(209, 49, 31)`
 */
export const bgFillNegativeSelected = 'var(--cb-color-bg-fill-negative-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FA5A48` / `rgb(250, 90, 72)`
 *   - dark: `#9F2518` / `rgb(159, 37, 24)`
 */
export const bgFillNegativeDisabled = 'var(--cb-color-bg-fill-negative-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#F93A25` / `rgb(249, 58, 37)`
 *   - dark: `#F93A25` / `rgb(249, 58, 37)`
 */
export const textNegative = 'var(--cb-color-text-negative)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#F93A25EB` / `rgba(249, 58, 37, 0.92)`
 *   - dark: `#F93A25EB` / `rgba(249, 58, 37, 0.92)`
 */
export const textNegativeHovered = 'var(--cb-color-text-negative-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#F93A25CC` / `rgba(249, 58, 37, 0.8)`
 *   - dark: `#F93A25CC` / `rgba(249, 58, 37, 0.8)`
 */
export const textNegativePressed = 'var(--cb-color-text-negative-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#F93A25E0` / `rgba(249, 58, 37, 0.88)`
 *   - dark: `#F93A25E0` / `rgba(249, 58, 37, 0.88)`
 */
export const textNegativeSelected = 'var(--cb-color-text-negative-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FDB0A8` / `rgb(253, 176, 168)`
 *   - dark: `#F93A2566` / `rgba(249, 58, 37, 0.4)`
 */
export const textNegativeDisabled = 'var(--cb-color-text-negative-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillNegative = 'var(--cb-color-text-on-bg-fill-negative)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillNegativeHovered = 'var(--cb-color-text-on-bg-fill-negative-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillNegativePressed = 'var(--cb-color-text-on-bg-fill-negative-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillNegativeSelected = 'var(--cb-color-text-on-bg-fill-negative-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FDB0A8` / `rgb(253, 176, 168)`
 *   - dark: `#CD8E87` / `rgb(205, 142, 135)`
 */
export const textOnBgFillNegativeDisabled = 'var(--cb-color-text-on-bg-fill-negative-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFF8EC` / `rgb(255, 248, 236)`
 *   - dark: `#1E0C00` / `rgb(30, 12, 0)`
 */
export const bgSurfaceWarning = 'var(--cb-color-bg-surface-warning)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFF1D8` / `rgb(255, 241, 216)`
 *   - dark: `#3C1800` / `rgb(60, 24, 0)`
 */
export const bgSurfaceWarningHovered = 'var(--cb-color-bg-surface-warning-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFEAC5` / `rgb(255, 234, 197)`
 *   - dark: `#511F00` / `rgb(81, 31, 0)`
 */
export const bgSurfaceWarningPressed = 'var(--cb-color-bg-surface-warning-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFF5E2` / `rgb(255, 245, 226)`
 *   - dark: `#321400` / `rgb(50, 20, 0)`
 */
export const bgSurfaceWarningSelected = 'var(--cb-color-bg-surface-warning-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFFCF5` / `rgb(255, 252, 245)`
 *   - dark: `#1E0C00` / `rgb(30, 12, 0)`
 */
export const bgSurfaceWarningDisabled = 'var(--cb-color-bg-surface-warning-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FC6200` / `rgb(252, 98, 0)`
 *   - dark: `#FC6200` / `rgb(252, 98, 0)`
 */
export const bgFillWarning = 'var(--cb-color-bg-fill-warning)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FC751F` / `rgb(252, 117, 31)`
 *   - dark: `#DE5600` / `rgb(222, 86, 0)`
 */
export const bgFillWarningHovered = 'var(--cb-color-bg-fill-warning-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FD8133` / `rgb(253, 129, 51)`
 *   - dark: `#CA4E00` / `rgb(202, 78, 0)`
 */
export const bgFillWarningPressed = 'var(--cb-color-bg-fill-warning-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FD7B29` / `rgb(253, 123, 41)`
 *   - dark: `#D45200` / `rgb(212, 82, 0)`
 */
export const bgFillWarningSelected = 'var(--cb-color-bg-fill-warning-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FD9B5C` / `rgb(253, 155, 92)`
 *   - dark: `#A13F00` / `rgb(161, 63, 0)`
 */
export const bgFillWarningDisabled = 'var(--cb-color-bg-fill-warning-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FC6200` / `rgb(252, 98, 0)`
 *   - dark: `#FC6200` / `rgb(252, 98, 0)`
 */
export const textWarning = 'var(--cb-color-text-warning)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FC6200EB` / `rgba(252, 98, 0, 0.92)`
 *   - dark: `#FC6200EB` / `rgba(252, 98, 0, 0.92)`
 */
export const textWarningHovered = 'var(--cb-color-text-warning-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FC6200CC` / `rgba(252, 98, 0, 0.8)`
 *   - dark: `#FC6200CC` / `rgba(252, 98, 0, 0.8)`
 */
export const textWarningPressed = 'var(--cb-color-text-warning-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FC6200E0` / `rgba(252, 98, 0, 0.88)`
 *   - dark: `#FC6200E0` / `rgba(252, 98, 0, 0.88)`
 */
export const textWarningSelected = 'var(--cb-color-text-warning-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FC620066` / `rgba(252, 98, 0, 0.4)`
 *   - dark: `#FC620066` / `rgba(252, 98, 0, 0.4)`
 */
export const textWarningDisabled = 'var(--cb-color-text-warning-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillWarning = 'var(--cb-color-text-on-bg-fill-warning)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillWarningHovered = 'var(--cb-color-text-on-bg-fill-warning-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillWarningPressed = 'var(--cb-color-text-on-bg-fill-warning-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillWarningSelected = 'var(--cb-color-text-on-bg-fill-warning-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FEC39D` / `rgb(254, 195, 157)`
 *   - dark: `#CE9B7A` / `rgb(206, 155, 122)`
 */
export const textOnBgFillWarningDisabled = 'var(--cb-color-text-on-bg-fill-warning-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#EDFBEB` / `rgb(237, 251, 235)`
 *   - dark: `#052002` / `rgb(5, 32, 2)`
 */
export const bgSurfacePositive = 'var(--cb-color-bg-surface-positive)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#DBF6D8` / `rgb(219, 246, 216)`
 *   - dark: `#073002` / `rgb(7, 48, 2)`
 */
export const bgSurfacePositiveHovered = 'var(--cb-color-bg-surface-positive-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#C9F2C4` / `rgb(201, 242, 196)`
 *   - dark: `#0A4003` / `rgb(10, 64, 3)`
 */
export const bgSurfacePositivePressed = 'var(--cb-color-bg-surface-positive-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E4F8E2` / `rgb(228, 248, 226)`
 *   - dark: `#062802` / `rgb(6, 40, 2)`
 */
export const bgSurfacePositiveSelected = 'var(--cb-color-bg-surface-positive-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#F6FDF5` / `rgb(246, 253, 245)`
 *   - dark: `#041801` / `rgb(4, 24, 1)`
 */
export const bgSurfacePositiveDisabled = 'var(--cb-color-bg-surface-positive-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#1FC70A` / `rgb(31, 199, 10)`
 *   - dark: `#1FC70A` / `rgb(31, 199, 10)`
 */
export const bgFillPositive = 'var(--cb-color-bg-fill-positive)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#3ACE27` / `rgb(58, 206, 39)`
 *   - dark: `#1BAF09` / `rgb(27, 175, 9)`
 */
export const bgFillPositiveHovered = 'var(--cb-color-bg-fill-positive-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#4CD23B` / `rgb(76, 210, 59)`
 *   - dark: `#168F07` / `rgb(22, 143, 7)`
 */
export const bgFillPositivePressed = 'var(--cb-color-bg-fill-positive-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#43D031` / `rgb(67, 208, 49)`
 *   - dark: `#1AA708` / `rgb(26, 167, 8)`
 */
export const bgFillPositiveSelected = 'var(--cb-color-bg-fill-positive-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#70DB62` / `rgb(112, 219, 98)`
 *   - dark: `#147F06` / `rgb(20, 127, 6)`
 */
export const bgFillPositiveDisabled = 'var(--cb-color-bg-fill-positive-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#1FC70A` / `rgb(31, 199, 10)`
 *   - dark: `#1FC70A` / `rgb(31, 199, 10)`
 */
export const textPositive = 'var(--cb-color-text-positive)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#1FC70AEB` / `rgba(31, 199, 10, 0.92)`
 *   - dark: `#1FC70AEB` / `rgba(31, 199, 10, 0.92)`
 */
export const textPositiveHovered = 'var(--cb-color-text-positive-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#1FC70ACC` / `rgba(31, 199, 10, 0.8)`
 *   - dark: `#1FC70ACC` / `rgba(31, 199, 10, 0.8)`
 */
export const textPositivePressed = 'var(--cb-color-text-positive-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#1FC70AE0` / `rgba(31, 199, 10, 0.88)`
 *   - dark: `#1FC70AE0` / `rgba(31, 199, 10, 0.88)`
 */
export const textPositiveSelected = 'var(--cb-color-text-positive-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#1FC70A66` / `rgba(31, 199, 10, 0.4)`
 *   - dark: `#1FC70A66` / `rgba(31, 199, 10, 0.4)`
 */
export const textPositiveDisabled = 'var(--cb-color-text-positive-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillPositive = 'var(--cb-color-text-on-bg-fill-positive)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillPositiveHovered = 'var(--cb-color-text-on-bg-fill-positive-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillPositivePressed = 'var(--cb-color-text-on-bg-fill-positive-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillPositiveSelected = 'var(--cb-color-text-on-bg-fill-positive-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#A9E9A1` / `rgb(169, 233, 161)`
 *   - dark: `#85BC7E` / `rgb(133, 188, 126)`
 */
export const textOnBgFillPositiveDisabled = 'var(--cb-color-text-on-bg-fill-positive-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#1F1F1F` / `rgb(31, 31, 31)`
 *   - dark: `#EDEDEE` / `rgb(237, 237, 238)`
 */
export const bgSurfaceInverse = 'var(--cb-color-bg-surface-inverse)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#333333` / `rgb(51, 51, 51)`
 *   - dark: `#DBDBDC` / `rgb(219, 219, 220)`
 */
export const bgSurfaceInverseHovered = 'var(--cb-color-bg-surface-inverse-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#3D3D3D` / `rgb(61, 61, 61)`
 *   - dark: `#C9CACB` / `rgb(201, 202, 203)`
 */
export const bgSurfaceInversePressed = 'var(--cb-color-bg-surface-inverse-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#292929` / `rgb(41, 41, 41)`
 *   - dark: `#E4E4E5` / `rgb(228, 228, 229)`
 */
export const bgSurfaceInverseSelected = 'var(--cb-color-bg-surface-inverse-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#141414` / `rgb(20, 20, 20)`
 *   - dark: `#F6F6F6` / `rgb(246, 246, 246)`
 */
export const bgSurfaceInverseDisabled = 'var(--cb-color-bg-surface-inverse-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#000000` / `rgb(0, 0, 0)`
 */
export const bgFillInverse = 'var(--cb-color-bg-fill-inverse)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#EDEDEE` / `rgb(237, 237, 238)`
 *   - dark: `#1F1F1F` / `rgb(31, 31, 31)`
 */
export const bgFillInverseHovered = 'var(--cb-color-bg-fill-inverse-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#DBDBDC` / `rgb(219, 219, 220)`
 *   - dark: `#333333` / `rgb(51, 51, 51)`
 */
export const bgFillInversePressed = 'var(--cb-color-bg-fill-inverse-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E4E4E5` / `rgb(228, 228, 229)`
 *   - dark: `#292929` / `rgb(41, 41, 41)`
 */
export const bgFillInverseSelected = 'var(--cb-color-bg-fill-inverse-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#F6F6F6` / `rgb(246, 246, 246)`
 *   - dark: `#141414` / `rgb(20, 20, 20)`
 */
export const bgFillInverseDisabled = 'var(--cb-color-bg-fill-inverse-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#000000` / `rgb(0, 0, 0)`
 */
export const textInverse = 'var(--cb-color-text-inverse)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#EBEBEB` / `rgb(235, 235, 235)`
 *   - dark: `#313236` / `rgb(49, 50, 54)`
 */
export const textInverseHovered = 'var(--cb-color-text-inverse-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#CCCCCC` / `rgb(204, 204, 204)`
 *   - dark: `#4D4D51` / `rgb(77, 77, 81)`
 */
export const textInversePressed = 'var(--cb-color-text-inverse-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#E0E0E0` / `rgb(224, 224, 224)`
 *   - dark: `#3B3C40` / `rgb(59, 60, 64)`
 */
export const textInverseSelected = 'var(--cb-color-text-inverse-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#666666` / `rgb(102, 102, 102)`
 *   - dark: `#A6A6A8` / `rgb(166, 166, 168)`
 */
export const textInverseDisabled = 'var(--cb-color-text-inverse-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillInverse = 'var(--cb-color-text-on-bg-fill-inverse)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillInverseHovered = 'var(--cb-color-text-on-bg-fill-inverse-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillInversePressed = 'var(--cb-color-text-on-bg-fill-inverse-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillInverseSelected = 'var(--cb-color-text-on-bg-fill-inverse-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#646567` / `rgb(100, 101, 103)`
 *   - dark: `#9D9D9D` / `rgb(157, 157, 157)`
 */
export const textOnBgFillInverseDisabled = 'var(--cb-color-text-on-bg-fill-inverse-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFA3` / `rgba(255, 255, 255, 0.64)`
 *   - dark: `#202125A3` / `rgba(32, 33, 37, 0.64)`
 */
export const bgSurfaceTransparent = 'var(--cb-color-bg-surface-transparent)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFCC` / `rgba(255, 255, 255, 0.8)`
 *   - dark: `#202125CC` / `rgba(32, 33, 37, 0.8)`
 */
export const bgSurfaceTransparentHovered = 'var(--cb-color-bg-surface-transparent-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFE0` / `rgba(255, 255, 255, 0.88)`
 *   - dark: `#202125E0` / `rgba(32, 33, 37, 0.88)`
 */
export const bgSurfaceTransparentPressed = 'var(--cb-color-bg-surface-transparent-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFB8` / `rgba(255, 255, 255, 0.72)`
 *   - dark: `#202125B8` / `rgba(32, 33, 37, 0.72)`
 */
export const bgSurfaceTransparentSelected = 'var(--cb-color-bg-surface-transparent-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF5C` / `rgba(255, 255, 255, 0.36)`
 *   - dark: `#2021255C` / `rgba(32, 33, 37, 0.36)`
 */
export const bgSurfaceTransparentDisabled = 'var(--cb-color-bg-surface-transparent-disabled)';

/**
 * A surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFEB` / `rgba(255, 255, 255, 0.92)`
 *   - dark: `#202125EB` / `rgba(32, 33, 37, 0.92)`
 */
export const bgFillTransparent = 'var(--cb-color-bg-fill-transparent)';

/**
 * A surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFCC` / `rgba(255, 255, 255, 0.8)`
 *   - dark: `#202125CC` / `rgba(32, 33, 37, 0.8)`
 */
export const bgFillTransparentHovered = 'var(--cb-color-bg-fill-transparent-hovered)';

/**
 * A surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFE0` / `rgba(255, 255, 255, 0.88)`
 *   - dark: `#202125E0` / `rgba(32, 33, 37, 0.88)`
 */
export const bgFillTransparentPressed = 'var(--cb-color-bg-fill-transparent-pressed)';

/**
 * A surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFB8` / `rgba(255, 255, 255, 0.72)`
 *   - dark: `#202125B8` / `rgba(32, 33, 37, 0.72)`
 */
export const bgFillTransparentSelected = 'var(--cb-color-bg-fill-transparent-selected)';

/**
 * A surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFFA3` / `rgba(255, 255, 255, 0.64)`
 *   - dark: `#202125A3` / `rgba(32, 33, 37, 0.64)`
 */
export const bgFillTransparentDisabled = 'var(--cb-color-bg-fill-transparent-disabled)';

/**
 * A label that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textTransparent = 'var(--cb-color-text-transparent)';

/**
 * A label that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#202125EB` / `rgba(32, 33, 37, 0.92)`
 *   - dark: `#FFFFFFEB` / `rgba(255, 255, 255, 0.92)`
 */
export const textTransparentHovered = 'var(--cb-color-text-transparent-hovered)';

/**
 * A label that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#202125CC` / `rgba(32, 33, 37, 0.8)`
 *   - dark: `#FFFFFFCC` / `rgba(255, 255, 255, 0.8)`
 */
export const textTransparentPressed = 'var(--cb-color-text-transparent-pressed)';

/**
 * A label that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#202125E0` / `rgba(32, 33, 37, 0.88)`
 *   - dark: `#FFFFFFE0` / `rgba(255, 255, 255, 0.88)`
 */
export const textTransparentSelected = 'var(--cb-color-text-transparent-selected)';

/**
 * A label that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#20212566` / `rgba(32, 33, 37, 0.4)`
 *   - dark: `#FFFFFF66` / `rgba(255, 255, 255, 0.4)`
 */
export const textTransparentDisabled = 'var(--cb-color-text-transparent-disabled)';

/**
 * A label on a surface that's interactive.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillTransparent = 'var(--cb-color-text-on-bg-fill-transparent)';

/**
 * A label on a surface that's interactive and hovered.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillTransparentHovered = 'var(--cb-color-text-on-bg-fill-transparent-hovered)';

/**
 * A label on a surface that's interactive and pressed.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillTransparentPressed = 'var(--cb-color-text-on-bg-fill-transparent-pressed)';

/**
 * A label on a surface that's interactive and selected.
 *
 * Reference color on default theme:
 *   - light: `#202125` / `rgb(32, 33, 37)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const textOnBgFillTransparentSelected =
  'var(--cb-color-text-on-bg-fill-transparent-selected)';

/**
 * A label on a surface that's interactive and unavailable.
 *
 * Reference color on default theme:
 *   - light: `#2021257A` / `rgba(32, 33, 37, 0.48)`
 *   - dark: `#FFFFFF7A` / `rgba(255, 255, 255, 0.48)`
 */
export const textOnBgFillTransparentDisabled =
  'var(--cb-color-text-on-bg-fill-transparent-disabled)';

/**
 * A surface that overlays an interface.
 *
 * Reference color on default theme:
 *   - light: `#00000052` / `rgba(0, 0, 0, 0.32)`
 *   - dark: `#00000052` / `rgba(0, 0, 0, 0.32)`
 */
export const bgOverlay = 'var(--cb-color-bg-overlay)';

/**
 * A fixed color.
 *
 * Reference color on default theme:
 *   - light: `#FFFFFF` / `rgb(255, 255, 255)`
 *   - dark: `#FFFFFF` / `rgb(255, 255, 255)`
 */
export const fixedWhite = 'var(--cb-color-fixed-white)';

/**
 * A fixed color.
 *
 * Reference color on default theme:
 *   - light: `#000000` / `rgb(0, 0, 0)`
 *   - dark: `#000000` / `rgb(0, 0, 0)`
 */
export const fixedBlack = 'var(--cb-color-fixed-black)';

/**
 * The color for shadows.
 *
 * Reference color on default theme:
 *   - light: `#0000001f` / `rgba(0, 0, 0, 0.12)`
 *   - dark: `#0000005c` / `rgba(0, 0, 0, 0.36)`
 */
export const shadow = 'var(--cb-color-shadow)';
